import React, { Component } from "react";
import axios from "axios";
import SpinnerLoader from "../../components/common/SpinnerLoader";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import Header from "../../components/admin/common/Header";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import store from "../../store";
import arrow_back from "./../../assets/icons/arrow-back.svg";
import emptyImg from "./../../assets/images/emptyimage.png";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { Modal, Button, Form, Row, Col, Tabs, Tab, Card } from "react-bootstrap";
import config from "../../config.json";

class AdminLicenses extends Component {
  constructor(props) {
    super(props);
    this.authInfo = store.getState().auth.authInfo;
    this.state = {
      emptyImg: emptyImg,
      data: [],
      loading: false,
      showModal: false,
      showActionModal: false,
      selectedLicense: null,
      activeTab: 'all',
      stats: {
        total: 0,
        pending: 0,
        approved: 0,
        rejected: 0
      },
      actionType: '', // 'approve' or 'reject'
      adminComments: ''
    };

    const adminId = this.authInfo.id;

    this.licenses_column = [
      {
        name: "License Name",
        selector: (row, i) => row.license_name,
        sortable: true,
      },
      {
        name: "License Number",
        selector: (row, i) => row.license_number,
        sortable: true,
      },
      {
        name: "Seller",
        selector: (row, i) => (
          <div>
            <div><strong>{row.seller_id?.name || 'N/A'}</strong></div>
            <div className="text-muted small">{row.seller_id?.email || 'N/A'}</div>
          </div>
        ),
        sortable: true,
      },
      {
        name: "Documents",
        selector: (row, i) => `${row.documents.length} file(s)`,
        sortable: true,
      },
      {
        name: "Status",
        cell: (row, i) => {
          const statusColors = {
            pending: 'warning',
            approved: 'success',
            rejected: 'danger'
          };
          return (
            <span className={`badge bg-${statusColors[row.status]}`}>
              {row.status.charAt(0).toUpperCase() + row.status.slice(1)}
            </span>
          );
        },
      },
      {
        name: "Submitted",
        selector: (row, i) => new Date(row.createdAt).toLocaleDateString(),
        sortable: true,
      },
      {
        name: "Action",
        cell: (row, i) => {
          return (
            <div className="dropdown">
                <button
                    className="btn btn-sm btn-light"
                    type="button"
                    id={`dropdownMenuButton-${row._id}`}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                    ⋮
                </button>
                <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton-${row._id}`}>
                    <li>
                    <button
                        className="dropdown-item"
                        onClick={() => this.handleShowDetailsModal(row)}
                    >
                        Details
                    </button>
                    </li>
                    {row.status === 'pending' && (
                    <>
                        <li>
                        <button
                            className="dropdown-item text-success"
                            onClick={() => this.handleShowActionModal(row, 'approve')}
                        >
                            Approve
                        </button>
                        </li>
                        <li>
                        <button
                            className="dropdown-item text-danger"
                            onClick={() => this.handleShowActionModal(row, 'reject')}
                        >
                            Reject
                        </button>
                        </li>
                    </>
                    )}
                </ul>
                </div>
          );
        },
      },
    ];
  }

  componentDidMount() {
    console.log("Component has mounted");
    this.getAllLicenses();
    this.getLicenseStats();
  }

  // Get all licenses based on active tab
    getAllLicenses = async (status = null) => {
        this.setState({ loading: true });
        try {
            let url = `/admin/licenses/all?adminId=${this.authInfo.id}`;
            if (status === 'pending') url = `/admin/licenses/pending?adminId=${this.authInfo.id}`;
            else if (status === 'approved') url = `/admin/licenses/approved?adminId=${this.authInfo.id}`;
            else if (status === 'rejected') url = `/admin/licenses/rejected?adminId=${this.authInfo.id}`;

            const response = await axios.get(url, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=UTF-8",
                Authorization: `Bearer ${this.authInfo.token}`,
            },
            });

            this.setState({ data: response.data.data.docs, loading: false });
        } catch (error) {
            console.error("Error fetching licenses:", error);
            toast.error("Failed to fetch licenses");
            this.setState({ loading: false });
        }
    };

  // Get license statistics
    getLicenseStats = async () => {
    try {
        const response = await axios.get(`/admin/licenses/stats?adminId=${this.authInfo.id}`, {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: `Bearer ${this.authInfo.token}`,
        },
        });
        this.setState({ stats: response.data.data });
    } catch (error) {
        console.error("Error fetching license stats:", error);
        }
    };


  // Handle tab change
  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
    const statusMap = {
      'all': null,
      'pending': 'pending',
      'approved': 'approved',
      'rejected': 'rejected'
    };
    this.getAllLicenses(statusMap[tab]);
  };

  // Show details modal
  handleShowDetailsModal = (license) => {
    this.setState({
      showModal: true,
      selectedLicense: license,
    });
  };

  // Close details modal
  handleCloseModal = () => {
    this.setState({
      showModal: false,
      selectedLicense: null
    });
  };

  // Show action modal (approve/reject)
  handleShowActionModal = (license, actionType) => {
    this.setState({
      showActionModal: true,
      selectedLicense: license,
      actionType: actionType,
      adminComments: ''
    });
  };

  // Close action modal
  handleCloseActionModal = () => {
    this.setState({
      showActionModal: false,
      selectedLicense: null,
      actionType: '',
      adminComments: ''
    });
  };

  // Handle admin comments change
  handleCommentsChange = (e) => {
    this.setState({ adminComments: e.target.value });
  };

  // Approve license
  handleApproveLicense = async () => {
    const { selectedLicense, adminComments } = this.state;
    this.setState({ loading: true });

    try {
        const response = await axios.put(
        `/admin/licenses/${selectedLicense.id}/approve`,
        {
            comments: adminComments,
            adminId: this.authInfo.id  // Add this line
        },
        {
            headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: `Bearer ${this.authInfo.token}`,
            },
        }
        );

        toast.success("License approved successfully");
        this.handleCloseActionModal();
        this.getAllLicenses();
        this.getLicenseStats();
    } catch (error) {
        console.error("Error approving license:", error);
        toast.error(error.response?.data?.message || "Failed to approve license");
    } finally {
        this.setState({ loading: false });
    }
    };

  // Reject license
  handleRejectLicense = async () => {
    const { selectedLicense, adminComments } = this.state;

    if (!adminComments.trim()) {
        toast.error("Please provide a reason for rejection");
        return;
    }

    this.setState({ loading: true });

    try {
        const response = await axios.put(
        `/admin/licenses/${selectedLicense.id}/reject`,
        {
            comments: adminComments,
            adminId: this.authInfo.id  // Add this line
        },
        {
            headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: `Bearer ${this.authInfo.token}`,
            },
        }
        );

        toast.success("License rejected successfully");
        this.handleCloseActionModal();
        this.getAllLicenses();
        this.getLicenseStats();
    } catch (error) {
        console.error("Error rejecting license:", error);
        toast.error(error.response?.data?.message || "Failed to reject license");
    } finally {
        this.setState({ loading: false });
    }
    };

  // Handle action submission
  handleActionSubmit = () => {
    if (this.state.actionType === 'approve') {
      this.handleApproveLicense();
    } else if (this.state.actionType === 'reject') {
      this.handleRejectLicense();
    }
  };

  render() {
    const { data, loading, selectedLicense, stats, activeTab, actionType, adminComments } = this.state;

    if (loading && data.length === 0) {
      return <SpinnerLoader />;
    }

    return (
      <React.Fragment>
        <div className="seller_dash_wrap pb-5">
          <div className="container">
            <Header />
            <div className="inr_top_page_title">
              <h2>Manage Licenses</h2>
            </div>
            <Helmet>
              <title>{"Admin - Manage Licenses - Pay Earth"}</title>
            </Helmet>

            {/* Statistics Cards */}
            <div className="row mb-4">
              <div className="col-lg-3 col-md-6 mb-3">
                <Card className="h-100">
                  <Card.Body className="text-center">
                    <h3 className="text-primary">{stats.total}</h3>
                    <p className="mb-0">Total Licenses</p>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-lg-3 col-md-6 mb-3">
                <Card className="h-100">
                  <Card.Body className="text-center">
                    <h3 className="text-warning">{stats.pending}</h3>
                    <p className="mb-0">Pending</p>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-lg-3 col-md-6 mb-3">
                <Card className="h-100">
                  <Card.Body className="text-center">
                    <h3 className="text-success">{stats.approved}</h3>
                    <p className="mb-0">Approved</p>
                  </Card.Body>
                </Card>
              </div>
              <div className="col-lg-3 col-md-6 mb-3">
                <Card className="h-100">
                  <Card.Body className="text-center">
                    <h3 className="text-danger">{stats.rejected}</h3>
                    <p className="mb-0">Rejected</p>
                  </Card.Body>
                </Card>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="createpost bg-white rounded-3 mt-2 addPost_left_container">
                  <div className="dash_inner_wrap pb-2">
                    <div className="col-md-12 pt-2 pb-3 d-flex justify-content-between align-items-center">
                      <div className="dash_title">Manage Licenses</div>
                      <div>
                        <button
                          type="button"
                          className="btn custum_back_btn btn_yellow mx-auto"
                          onClick={() => window.history.back()}
                        >
                          <img src={arrow_back} alt="back" />&nbsp;
                          Back
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Tabs */}
                  <div className="cp_body">
                    <Tabs
                      activeKey={activeTab}
                      onSelect={this.handleTabChange}
                      className="mb-3"
                    >
                      <Tab eventKey="all" title="All Licenses">
                        <DataTableExtensions
                          columns={this.licenses_column}
                          data={data}
                        >
                          <DataTable
                            pagination
                            noHeader
                            highlightOnHover
                            defaultSortField="createdAt"
                            defaultSortAsc={false}
                            paginationPerPage={7}
                            paginationRowsPerPageOptions={[7, 14, 21, 60]}
                          />
                        </DataTableExtensions>
                      </Tab>
                      <Tab eventKey="pending" title={`Pending (${stats.pending})`}>
                        <DataTableExtensions
                          columns={this.licenses_column}
                          data={data}
                        >
                          <DataTable
                            pagination
                            noHeader
                            highlightOnHover
                            defaultSortField="createdAt"
                            defaultSortAsc={false}
                            paginationPerPage={7}
                            paginationRowsPerPageOptions={[7, 14, 21, 60]}
                          />
                        </DataTableExtensions>
                      </Tab>
                      <Tab eventKey="approved" title={`Approved (${stats.approved})`}>
                        <DataTableExtensions
                          columns={this.licenses_column}
                          data={data}
                        >
                          <DataTable
                            pagination
                            noHeader
                            highlightOnHover
                            defaultSortField="createdAt"
                            defaultSortAsc={false}
                            paginationPerPage={7}
                            paginationRowsPerPageOptions={[7, 14, 21, 60]}
                          />
                        </DataTableExtensions>
                      </Tab>
                      <Tab eventKey="rejected" title={`Rejected (${stats.rejected})`}>
                        <DataTableExtensions
                          columns={this.licenses_column}
                          data={data}
                        >
                          <DataTable
                            pagination
                            noHeader
                            highlightOnHover
                            defaultSortField="createdAt"
                            defaultSortAsc={false}
                            paginationPerPage={7}
                            paginationRowsPerPageOptions={[7, 14, 21, 60]}
                          />
                        </DataTableExtensions>
                      </Tab>
                    </Tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Details Modal */}
        <Modal
          show={this.state.showModal}
          onHide={this.handleCloseModal}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>License Details</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "calc(100vh - 100px)", overflowY: "auto" }}>
            {selectedLicense && (
              <div>
                {/* Seller Information */}
                <Card className="mb-3">
                  <Card.Header>
                    <h5>Seller Information</h5>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col md={6}>
                        <strong>Name:</strong> {selectedLicense.seller_id?.name || 'N/A'}
                      </Col>
                      <Col md={6}>
                        <strong>Email:</strong> {selectedLicense.seller_id?.email || 'N/A'}
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                {/* License Information */}
                <Card className="mb-3">
                  <Card.Header>
                    <h5>License Information</h5>
                  </Card.Header>
                  <Card.Body>
                    <Row className="mb-3">
                      <Col md={6}>
                        <strong>License Name:</strong> {selectedLicense.license_name}
                      </Col>
                      <Col md={6}>
                        <strong>License Number:</strong> {selectedLicense.license_number}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md={6}>
                        <strong>Status:</strong>
                        <span className={`badge bg-${selectedLicense.status === 'pending' ? 'warning' :
                          selectedLicense.status === 'approved' ? 'success' : 'danger'} ms-2`}>
                          {selectedLicense.status.charAt(0).toUpperCase() + selectedLicense.status.slice(1)}
                        </span>
                      </Col>
                      <Col md={6}>
                        <strong>Submitted:</strong> {new Date(selectedLicense.createdAt).toLocaleDateString()}
                      </Col>
                    </Row>
                    {selectedLicense.reviewed_at && (
                      <Row className="mb-3">
                        <Col md={6}>
                          <strong>Reviewed By:</strong> {selectedLicense.reviewed_by?.name || 'N/A'}
                        </Col>
                        <Col md={6}>
                          <strong>Reviewed At:</strong> {new Date(selectedLicense.reviewed_at).toLocaleDateString()}
                        </Col>
                      </Row>
                    )}
                  </Card.Body>
                </Card>

                {/* Admin Comments */}
                {selectedLicense.admin_comments && (
                  <Card className="mb-3">
                    <Card.Header>
                      <h5>Admin Comments</h5>
                    </Card.Header>
                    <Card.Body>
                      <p className="mb-0">{selectedLicense.admin_comments}</p>
                    </Card.Body>
                  </Card>
                )}

                {/* Documents */}
                <Card className="mb-3">
                  <Card.Header>
                    <h5>Documents ({selectedLicense.documents.length})</h5>
                  </Card.Header>
                  <Card.Body>
                    <div className="row">
                      {selectedLicense.documents.map((doc, index) => (
                        <div key={index} className="col-md-4 mb-3">
                          <div className="card">
                            <div className="card-body text-center">
                              <div className="mb-2">
                                📄
                              </div>
                              <p className="small mb-2">{doc.file_name}</p>
                              <a
                                href={`${config.apiURI}${doc.file_url.startsWith('/') ? doc.file_url.substring(1) : doc.file_url}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-sm btn-outline-primary"
                              >
                                View
                              </a>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Card.Body>
                </Card>

                {/* Verification URLs */}
                {selectedLicense.verification_urls.length > 0 && (
                  <Card className="mb-3">
                    <Card.Header>
                      <h5>Verification URLs</h5>
                    </Card.Header>
                    <Card.Body>
                      {selectedLicense.verification_urls.map((urlObj, index) => (
                        <div key={index} className="mb-2">
                          <a href={urlObj.url} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                            🔗 {urlObj.url}
                          </a>
                          {urlObj.description && (
                            <p className="text-muted small mb-0 ms-3">{urlObj.description}</p>
                          )}
                        </div>
                      ))}
                    </Card.Body>
                  </Card>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            {selectedLicense && selectedLicense.status === 'pending' && (
              <>
                <Button
                  variant="success"
                  onClick={() => this.handleShowActionModal(selectedLicense, 'approve')}
                >
                  Approve
                </Button>
                <Button
                  variant="danger"
                  onClick={() => this.handleShowActionModal(selectedLicense, 'reject')}
                >
                  Reject
                </Button>
              </>
            )}
            <Button variant="secondary" onClick={this.handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Action Modal (Approve/Reject) */}
        <Modal
          show={this.state.showActionModal}
          onHide={this.handleCloseActionModal}
          dialogClassName="modal-50w"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {actionType === 'approve' ? 'Approve License' : 'Reject License'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedLicense && (
              <div>
                <div className="mb-3">
                  <strong>License:</strong> {selectedLicense.license_name} ({selectedLicense.license_number})
                </div>
                <div className="mb-3">
                  <strong>Seller:</strong> {selectedLicense.seller_id?.name}
                </div>
                <Form.Group className="mb-3">
                  <Form.Label>
                    {actionType === 'approve' ? 'Comments (Optional)' : 'Reason for Rejection *'}
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    value={adminComments}
                    onChange={this.handleCommentsChange}
                    placeholder={
                      actionType === 'approve'
                        ? 'Add any comments about the approval...'
                        : 'Please provide a reason for rejection...'
                    }
                    required={actionType === 'reject'}
                  />
                </Form.Group>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseActionModal}>
              Cancel
            </Button>
            <Button
              variant={actionType === 'approve' ? 'success' : 'danger'}
              onClick={this.handleActionSubmit}
              disabled={loading || (actionType === 'reject' && !adminComments.trim())}
            >
              {loading ? 'Processing...' : (actionType === 'approve' ? 'Approve License' : 'Reject License')}
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

export default AdminLicenses;
